import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import 'element-remove'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'app/i18n'
import Apollo from 'app/Apollo'
import Theme from 'app/Theme'
import history from 'app/history'
import ReactWidgetErrorBoundary from '../ReactWidgetErrorBoundary'
import ReactWidgetStyleManager from 'app/ReactWidgetStyleManager'
import PageHeader from 'containers/Page/Header/PageHeader'
import AppPersonState from 'context/AppPersonContext/AppPersonState'

// разместить этот элемент в том месте страницы, где нужен виджет
// серипт будет называется так же КАК НАЗВАНИЕ ЭТОГО ФАЙЛА
// <div id="page_header_react_widget">
// <script type="text/javascript" src="/sports/scripts/react-widgets/page_header.js?1"></script>

// получаем элемент
const element = document.getElementById('page_header_react_widget');

if (element) {
  // рендер виджета в указанный элемент
  // Apollo и Theme обязетнльны для создания необходимых контекстов
  // если нужны другие контексты, добавьте их сюда же внутри темы, обернув в них свой компонент
  ReactDOM.render(
    (
      <ReactWidgetErrorBoundary>
        <Apollo>
          <Router {...{history}}>
            <ReactWidgetStyleManager widgetId={element.id}>
              <Theme contain_styles_in_css_id={element.id}>
                <AppPersonState>
                  <PageHeader react_widget />
                </AppPersonState>
              </Theme>
            </ReactWidgetStyleManager>
          </Router>
        </Apollo>
      </ReactWidgetErrorBoundary>
    ),
    element
  )
}
